/* Helpers compartilhados do Painel de Vendas (BI). */
import { TrendUp, TrendDown } from "@phosphor-icons/react";

export function buildBiParams(f) {
  const p = { date_from: f.date_from, date_to: f.date_to, compare: f.compare || "prev" };
  ["stores", "types", "colors", "capacities", "skus"].forEach((k) => {
    if (f[k]?.length) p[k] = f[k].join(",");
  });
  if (f.qty_min !== "" && f.qty_min !== null && f.qty_min !== undefined) p.qty_min = f.qty_min;
  if (f.qty_max !== "" && f.qty_max !== null && f.qty_max !== undefined) p.qty_max = f.qty_max;
  return p;
}

export function fmtPct(v) {
  if (v === null || v === undefined) return "—";
  return `${v > 0 ? "+" : ""}${v}%`;
}

export function Delta({ pct, testid }) {
  if (pct === null || pct === undefined) return <span className="text-[10px] text-zinc-400" data-testid={testid}>—</span>;
  const up = pct >= 0;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[10px] font-bold ${up ? "text-green-600" : "text-red-500"}`} data-testid={testid}>
      {up ? <TrendUp size={11} weight="bold" /> : <TrendDown size={11} weight="bold" />}
      {Math.abs(pct)}%
    </span>
  );
}

export function GrowthCell({ pct }) {
  if (pct === null || pct === undefined) return <span className="text-zinc-400">—</span>;
  return (
    <span className={`font-mono font-bold ${pct >= 0 ? "text-green-600" : "text-red-500"}`}>
      {fmtPct(pct)}
    </span>
  );
}

export function ShareBar({ pct }) {
  return (
    <div className="flex items-center gap-1.5 min-w-[80px]">
      <div className="h-1.5 flex-1 bg-zinc-200 dark:bg-zinc-700 rounded overflow-hidden">
        <div className="h-full bg-black dark:bg-white rounded" style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
      <span className="text-[10px] font-mono text-zinc-500 w-10 text-right">{pct}%</span>
    </div>
  );
}

export function Panel({ title, children, testid, right, note }) {
  return (
    <div className="tile p-3" data-testid={testid}>
      <div className="flex items-center justify-between mb-2 gap-2 flex-wrap">
        <div className="overline text-[10px] text-zinc-500">{title}</div>
        {right}
      </div>
      {children}
      {note && <div className="text-[10px] text-zinc-400 mt-2">{note}</div>}
    </div>
  );
}

export function Empty() {
  return <div className="text-center text-zinc-400 text-xs py-8">Sem dados no período</div>;
}

export const fmtDateBR = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

const ABC_STYLE = {
  A: "bg-green-600 text-white",
  B: "bg-yellow-400 text-black",
  C: "bg-zinc-300 text-zinc-700 dark:bg-zinc-600 dark:text-zinc-100",
};

export function AbcBadge({ cls }) {
  return (
    <span className={`inline-block w-5 h-5 text-[10px] font-black text-center leading-5 rounded ${ABC_STYLE[cls] || ""}`}>
      {cls}
    </span>
  );
}
